module.exports = __webpack_public_path__ + "media/packs/images/@tehnobank/footer-image-kocmoc-2577bca9a8219a76794d34c61fe8ea4f.png";